import AssetImage from '@/components/asset-image';
import JobCard from '@/components/job-card';
import Link, { LinkVariant } from '@/components/link';
import Typography from '@/components/typography';

import JobCategoryJobBlocks, {
  JobCategoryJobBlocksProps,
} from '@/features/job-category-page/components/job-category-job-blocks';
import { Job } from '@/services/public-jobs.service';

export type JobsZeroResultsProps = {
  relatedJobs: Job[];
  jobBlocksProps: JobCategoryJobBlocksProps;
  title: string;
  subtitle: string;

  link: {
    href: string;
    text: string;
  };
};

export default function JobsZeroResults(props: JobsZeroResultsProps) {
  return (
    <>
      <div className='mb-16 flex flex-col items-center gap-8 px-8 text-center'>
        <Typography.Heading4>{props.title}</Typography.Heading4>
        <AssetImage
          src='/images/zero-jobs-search-result.png'
          alt='Zero Jobs Search Result'
          height={193}
          width={193}
        />
        <Typography.Body2>{props.subtitle}</Typography.Body2>
      </div>

      <div className='flex flex-col justify-center'>
        <div className='mx-auto mt-8 hidden flex-col gap-8 md:flex'>
          <div className='mx-auto mt-8 hidden w-full max-w-4xl grid-cols-2 gap-8 md:grid'>
            {props.relatedJobs.map((job) => (
              <div key={job.id} className='flex h-full w-full justify-center'>
                <JobCard key={job.id} {...job} />
              </div>
            ))}
          </div>

          <div className='flex justify-center'>
            <Link variant={LinkVariant.PRIMARY_BUTTON} href={props.link.href}>
              {props.link.text}
            </Link>
          </div>
        </div>

        <div className='w-full md:hidden'>
          <JobCategoryJobBlocks {...props.jobBlocksProps} />
        </div>
      </div>
    </>
  );
}
